<template>
  <div ref="myRef" class="card-skeleton" :class="classes">
    <div v-for="(card, index) in cardList" :key="index" class="card-item"></div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useResizeObserver } from '@vueuse/core';
import { CARD_SIZE_HEIGHT, CARD_SIZE_SPACE, CARD_SIZE_WIDTH } from './my-app.constants';

const props = defineProps({
  active: {
    type: Boolean,
    default: true,
  },
});

/**
 * 卡片尺寸
 */
const cardSize = ref({
  width: CARD_SIZE_WIDTH,
  height: CARD_SIZE_HEIGHT,
  space: CARD_SIZE_SPACE,
});

/** 根元素 */
const myRef = ref<HTMLElement | null>(null);
/** 卡片数 */
const cardNum = ref(0);

/** 卡片列表 */
const cardList = computed(() => {
  const { width, height } = cardSize.value;

  let res = [];
  for (let index = 0; index < cardNum.value; index++) {
    res.push({ width, height });
  }
  return res;
});
/** 样式 */
const classes = computed(() => {
  return [{ 'is-active': props.active }];
});

/**
 * 更新卡片数
 */
const setCardNum = () => {
  const rootDiv = myRef.value;
  if (!rootDiv) {
    return;
  }

  const rootWidth = getComputedStyle(rootDiv).width;
  const { width, space } = cardSize.value;
  cardNum.value = Math.floor(parseInt(rootWidth) / (width + space));
};

let resizeOb: ReturnType<typeof useResizeObserver>;
onMounted(() => {
  // 监测容器大小变化
  resizeOb = useResizeObserver(myRef.value, () => {
    setCardNum();
  });
});

onBeforeUnmount(() => {
  resizeOb?.stop?.();
});
</script>

<style lang="scss" scoped>
.card-skeleton {
  position: absolute;
  left: 24px;
  right: 24px;
  top: 20px;
  display: flex;
  flex-wrap: nowrap;
  // padding-bottom: 4px;
  // padding-left: 4px;
  // padding-right: 4px;

  .card-item {
    flex: none;
    box-sizing: border-box;
    width: v-bind('cardSize.width+"px"');
    height: v-bind('cardSize.height+"px"');
    margin-right: v-bind('cardSize.space+"px"');
    margin-top: 4px;
    background: linear-gradient(
      90deg,
      var(--lowcode-status-02) 25%,
      var(--lowcode-status-03) 37%,
      var(--lowcode-status-02) 63%
    );
    background-size: 400% 100%;
    border-radius: 4px;
    will-change: background-position;
    animation: skeleton-loading 1.4s ease infinite;
  }

  &.is-active {
    .fill {
      background: linear-gradient(
        90deg,
        var(--lowcode-status-02) 25%,
        var(--lowcode-status-03) 37%,
        var(--lowcode-status-02) 63%
      );
      background-size: 400% 100%;
      border-radius: 4px;
      will-change: background-position;
      animation: skeleton-loading 1.4s ease infinite;
    }
  }
}
</style>
